<template>
    <!--<router-link :to="{ path: '/user/downline', query: { uuid: params.value }}" @click.stop.prevent class="text-inherit hover:text-primary">-->
        <!--
        <div class="flex items-center">
                <vs-avatar v-if="params.data.avatar" :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" />
                <vs-avatar v-if="!params.data.avatar" :text="params.data.first_name + ' ' + params.data.last_name" class="flex-shrink-0 mr-2" size="30px" />
                <span style="margin-left: 10px;">{{params.value}}</span>
        </div>
        -->
    <span>
        <vs-avatar v-if="params.data.avatar" :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" />
        <vs-avatar v-if="!params.data.avatar" :text="params.data.first_name + ' ' + params.data.last_name" class="flex-shrink-0 mr-2" size="30px" />
    </span>
    <!--</router-link>-->
</template>

<script>
    export default {
        name: 'CellRendererAvatar'
    }
</script>
